import { put, select, take, takeEvery, takeLatest } from 'redux-saga/effects';
import { action as createAction, ActionType } from 'typesafe-actions';

import { IAcceptedDocument } from 'APIPackage/DictionariesModule/interfaces/IAcceptedDocument';
import { IChecklistDictionary } from 'APIPackage/DictionariesModule/interfaces/IChecklistDictionary';
import { IDangerClass248 } from 'APIPackage/DictionariesModule/interfaces/IDangerClass248';
import { IDictionary } from 'APIPackage/DictionariesModule/interfaces/IDictionary';
import { IDictionaryValue } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { IDictionaryValues } from 'APIPackage/DictionariesModule/interfaces/IDictionaryValues';
import { IDictionaryVersion } from 'APIPackage/DictionariesModule/interfaces/IDictionaryVersion';
import { IEventType } from 'APIPackage/DictionariesModule/interfaces/IEventType';
import { IKnmKind } from 'APIPackage/DictionariesModule/interfaces/IKnmKind';
import { IKnoOrganizationDictionary } from 'APIPackage/DictionariesModule/interfaces/IKnoOrganizationDictionary';
import { IParticipantPosition } from 'APIPackage/DictionariesModule/interfaces/IParticipantPosition';
import { IPosition } from 'APIPackage/DictionariesModule/interfaces/IPosition';
import { IProfKind } from 'APIPackage/DictionariesModule/interfaces/IProfKind';
import { IRequirement } from 'APIPackage/DictionariesModule/interfaces/IRequirement';
import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';
import { IRiskIndicatory } from 'APIPackage/DictionariesModule/interfaces/IRiskIndicatory';
import { ISubjectKind } from 'APIPackage/DictionariesModule/interfaces/ISubjectKind';
import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';
import { ISupervisionType } from 'APIPackage/DictionariesModule/interfaces/ISupervisionType';
import { IApplicationConditionSubject } from 'APIPackage/AccountModule/interfaces/IApplicationConditionSubject';
import {
  fetchAcceptedDocumentsDictionary,
  fetchAllDictionaries,
  fetchChecklistsDictionary,
  fetchDangerClassesDictionary,
  fetchDictionaryKnoOrganisationsSearch,
  fetchDictionaryValue,
  fetchDictionaryValues,
  fetchEventTypesDictionary,
  fetchGetEventUuid,
  fetchKnmKindsDictionary,
  fetchKnoOrganizationsDictionary,
  fetchParticipantPositionsDictionary,
  fetchPermitDocsDictionary,
  fetchPositionsDictionary,
  fetchProfKindsDictionary,
  fetchRequirementsDictionary,
  fetchRiskCategoriesDictionary,
  fetchRiskIndicatorsDictionary,
  fetchSubjectKindsDictionary,
  fetchSubjectSubKindsDictionary,
  fetchSubjectTypesDictionary,
  fetchSupervisionTypesDictionary,
  fetchDictionaryKnoSupervision,
  fetchTargetEntityDictionary,
  fetchSubjectTypesMultiDictionary,
  fetchSubjectKindsMultiDictionary,
  fetchSubjectSubKindsMultiDictionary,
  fetchGetDecisionKindsDictionary,
  fetchPmEventTypesDictionary,
  fetchSupervisionDictionaryValue,
  fetchApplicationConditionSubjects,
  fetchSubjectKindsDictionaryByQuery,
  fetchSubjectSubKindsDictionaryByQuery,
  findDocTargetsDictionary,
  fetchPmProfEventTypesDictionary,
  fetchSupervisionTypeBySubjectTypeDictionary,
  fetchGetEventHasUnplannedActivity,
  fetchTargetEntityFounderDictionary,
  fetchGetDecisionKindsAllDictionary,
} from 'APIPackage/DictionariesModule/services/dictionariesApi';
import { ITargetEntity } from 'APIPackage/DictionariesModule/interfaces/ITargetEntity';
import { sagaWrapper } from 'CorePackage/MainModule/common/sagaWrapper';
import { IDecisionKind } from 'APIPackage/DictionariesModule/interfaces/IDecisionKind';
import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';
import { IKnmSubjectTypesERVK } from 'APIPackage/CatalogsModule/interfaces/IKnmSubjectTypesERVK';
import { fetchFederalLawsByKno, fetchFederalLawsByKnoDirect } from 'APIPackage/CatalogsModule/services/federalLawsApi';
import {
  fetchKnoErvkOrganisationsChildrenWithAdminLevel,
  fetchKnoErvkOrganizationsSearch,
} from 'APIPackage/CatalogsModule/services/knoOrganisationsApi';

import { IPermitDocs } from '../../../APIPackage/DictionariesModule/interfaces/IPermitDocs';
import {
  dictionariesAcceptedDocumentsItemGet,
  dictionariesAcceptedDocumentsItemGetFailure,
  dictionariesAcceptedDocumentsItemGetRequest,
  dictionariesAcceptedDocumentsItemGetSuccess,
  dictionariesChecklistsItemGet,
  dictionariesChecklistsItemGetFailure,
  dictionariesChecklistsItemGetRequest,
  dictionariesChecklistsItemGetSuccess,
  dictionariesConditionTypesItemGet,
  dictionariesConditionTypesItemGetFailure,
  dictionariesConditionTypesItemGetRequest,
  dictionariesConditionTypesItemGetSuccess,
  dictionariesDangerClassesItemGet,
  dictionariesDangerClassesItemGetFailure,
  dictionariesDangerClassesItemGetRequest,
  dictionariesDangerClassesItemGetSuccess,
  dictionariesDecisionKindsItemGet,
  dictionariesDecisionKindsItemGetFailure,
  dictionariesDecisionKindsItemGetRequest,
  dictionariesDecisionKindsItemGetSuccess,
  dictionariesErvkCheckListGet,
  dictionariesErvkCheckListGetFailure,
  dictionariesErvkCheckListGetRequest,
  dictionariesErvkCheckListGetSuccess,
  dictionariesEventTypesItemGet,
  dictionariesEventTypesItemGetFailure,
  dictionariesEventTypesItemGetRequest,
  dictionariesEventTypesItemGetSuccess,
  dictionariesEventUuidGet,
  dictionariesEventUuidGetFailure,
  dictionariesEventUuidGetRequest,
  dictionariesEventUuidGetSuccess,
  dictionariesGetFailure,
  dictionariesGetRequest,
  dictionariesGetSuccess,
  dictionariesItemValueGet,
  dictionariesItemValueGetFailure,
  dictionariesItemValueGetFailureWithCallback,
  dictionariesItemValueGetNoData,
  dictionariesItemValueGetRequest,
  dictionariesItemValueGetRequestWithCallback,
  dictionariesItemValueGetSuccess,
  dictionariesItemValueGetSuccessWithCallback,
  dictionariesItemValueGetWithCallback,
  dictionariesItemValuesGet,
  dictionariesItemValuesGetFailure,
  dictionariesItemValuesGetRequest,
  dictionariesItemValuesGetSuccess,
  dictionariesKnmKindsItemGet,
  dictionariesKnmKindsItemGetFailure,
  dictionariesKnmKindsItemGetRequest,
  dictionariesKnmKindsItemGetSuccess,
  dictionariesKnoOrganizationsItemGetFailure,
  dictionariesKnoOrganizationsItemGetRequest,
  dictionariesKnoOrganizationsItemGetSuccess,
  dictionariesKnoSupervisionGet,
  dictionariesKnoSupervisionGetFailure,
  dictionariesKnoSupervisionGetRequest,
  dictionariesKnoSupervisionGetSuccess,
  dictionariesParticipantPositionsItemGet,
  dictionariesParticipantPositionsItemGetFailure,
  dictionariesParticipantPositionsItemGetRequest,
  dictionariesParticipantPositionsItemGetSuccess,
  dictionariesPermitDocsItemGet,
  dictionariesPermitDocsItemGetFailure,
  dictionariesPermitDocsItemGetRequest,
  dictionariesPermitDocsItemGetSuccess,
  dictionariesPositionsItemGet,
  dictionariesPositionsItemGetFailure,
  dictionariesPositionsItemGetRequest,
  dictionariesPositionsItemGetSuccess,
  dictionariesProfKindsItemGet,
  dictionariesProfKindsItemGetFailure,
  dictionariesProfKindsItemGetRequest,
  dictionariesProfKindsItemGetSuccess,
  dictionariesRequirementsItemGet,
  dictionariesRequirementsItemGetFailure,
  dictionariesRequirementsItemGetRequest,
  dictionariesRequirementsItemGetSuccess,
  dictionariesRiskCategoriesItemGet,
  dictionariesRiskCategoriesItemGetFailure,
  dictionariesRiskCategoriesItemGetRequest,
  dictionariesRiskCategoriesItemGetSuccess,
  dictionariesRiskIndicatorsItemGet,
  dictionariesRiskIndicatorsItemGetFailure,
  dictionariesRiskIndicatorsItemGetRequest,
  dictionariesRiskIndicatorsItemGetSuccess,
  dictionariesSubjectKindsItemGet,
  dictionariesSubjectKindsItemGetFailure,
  dictionariesSubjectKindsItemGetRequest,
  dictionariesSubjectKindsItemGetSuccess,
  dictionariesSubjectSubKindsItemGet,
  dictionariesSubjectSubKindsItemGetFailure,
  dictionariesSubjectSubKindsItemGetRequest,
  dictionariesSubjectSubKindsItemGetSuccess,
  dictionariesSubjectTypesItemGet,
  dictionariesSubjectTypesItemGetFailure,
  dictionariesSubjectTypesItemGetRequest,
  dictionariesSubjectTypesItemGetSuccess,
  dictionariesSupervisionTypesItemGet,
  dictionariesSupervisionTypesItemGetFailure,
  dictionariesSupervisionTypesItemGetRequest,
  dictionariesSupervisionTypesItemGetSuccess,
  dictionariesTargetEntityItemGet,
  dictionariesTargetEntityItemGetFailure,
  dictionariesTargetEntityItemGetRequest,
  dictionariesTargetEntityItemGetSuccess,
  dictionariesSubjectTypesMultiItemGet,
  dictionariesSubjectTypesMultiItemGetFailure,
  dictionariesSubjectTypesMultiItemGetRequest,
  dictionariesSubjectTypesMultiItemGetSuccess,
  dictionariesSubjectKindsMultiItemGet,
  dictionariesSubjectKindsMultiItemGetFailure,
  dictionariesSubjectKindsMultiItemGetRequest,
  dictionariesSubjectKindsMultiItemGetSuccess,
  dictionariesSubjectSubKindsMultiItemGet,
  dictionariesSubjectSubKindsMultiItemGetFailure,
  dictionariesSubjectSubKindsMultiItemGetRequest,
  dictionariesSubjectSubKindsMultiItemGetSuccess,
  IErvkListGetParams,
  supervisionDictionaryValueGet,
  dictionariesFederalLawsGetRequest,
  dictionariesFederalLawsGetSuccess,
  dictionariesFederalLawsGetFailure,
  dictionariesKnmSubjectTypesGetRequest,
  dictionariesKnmSubjectTypesGetSuccess,
  dictionariesKnmSubjectTypesGetFailure,
  dictionariesApplicationConditionSubjectsItemGetRequest,
  dictionariesApplicationConditionSubjectsItemGetSuccess,
  dictionariesApplicationConditionSubjectsItemGetFailure,
  dictionariesFilteredFederalLawsGet,
  dictionariesFilteredFederalLawsGetSuccess,
  dictionariesFilteredFederalLawsGetFailure,
  dictionariesFilteredFederalLawsGetRequest,
  dictionariesFindSubjectKindSelectOptionsByQuery,
  dictionariesFindSubjectSubKindSelectOptionsByQuery,
  dictionariesGetDocTargetSelectOptionsByQuery,
  dictionariesPmProfEventTypesItemGetRequest,
  dictionariesPmProfEventTypesItemGetSuccess,
  dictionariesPmProfEventTypesItemGetFailure,
  dictionariesPmProfEventTypesItemGet,
  dictionariesSupervisionTypesBySubjectTypeItemGet,
  dictionariesSupervisionTypesBySubjectTypeItemGetRequest,
  dictionariesSupervisionTypesBySubjectTypeItemGetSuccess,
  dictionariesSupervisionTypesBySubjectTypeItemGetFailure,
  dictionariesTargetEntityFounderItemGetRequest,
  dictionariesTargetEntityFounderItemGetSuccess,
  dictionariesTargetEntityFounderItemGetFailure,
  dictionariesDecisionKindsAllItemGetRequest,
  dictionariesDecisionKindsAllItemGetSuccess,
  dictionariesDecisionKindsAllItemGetFailure,
  dictionariesDecisionKindsAllItemGet,
  dictionariesItemValueGetAlreadyLoad,
  dictionariesEventHasUnplannedActivityGet,
  dictionariesEventHasUnplannedActivityGetRequest,
  dictionariesEventHasUnplannedActivityGetSuccess,
  dictionariesEventHasUnplannedActivityGetFailure,
} from '../actions/dictionariesActions';
import { dictionaryIdByName } from '../constants/dictionaryIdByName';
import { DictionariesActionsEnum } from '../enums/DictionariesActionsEnum';
import { DictionaryNamesEnum } from '../enums/DictionaryNamesEnum';
import { DictionaryStatusesEnum } from '../enums/DictionaryStatusesEnum';
import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';
import { IDictionaryValueTypeById } from '../interfaces/IDictionaryValueTypeById';
import {
  getDictionariesAcceptedDocumentsStatus,
  getDictionariesChecklistsStatus,
  getDictionariesConditionTypesStatus,
  getDictionariesDangerClassesStatus,
  getDictionariesEventTypesStatus,
  getDictionariesEventUuidStatus,
  getDictionariesItemsListStatus,
  getDictionariesItemValueData,
  getDictionariesItemValueStatus,
  getDictionariesKnmKindsStatus,
  getDictionariesKnoOrganizationsStatus,
  getDictionariesKnoSupervisionStatus,
  getDictionariesParticipantPositionsStatus,
  getDictionariesPermitDocsStatus,
  getDictionariesPositionsStatus,
  getDictionariesProfKindsStatus,
  getDictionariesRequirementsStatus,
  getDictionariesRiskCategoriesStatus,
  getDictionariesRiskIndicatorsStatus,
  getDictionariesSubjectKindsStatus,
  getDictionariesSubjectSubKindsStatus,
  getDictionariesSubjectTypesStatus,
  getDictionariesSubjectTypesData,
  getDictionariesSubjectKindsData,
  getDictionariesSubjectSubKindsData,
  getDictionariesSupervisionTypesStatus,
  getDictionariesTargetEntityStatus,
  getDictionariesSubjectTypesMultiStatus,
  getDictionariesSubjectKindsMultiStatus,
  getDictionariesSubjectSubKindsMultiStatus,
  getErvkCheckListStatus,
  makeGetDictionaryValuesStatus,
  getKnmSubjectTypesStatus,
  getDictionariesApplicationConditionSubjectsStatus,
  getDictionariesPmProfEventTypesStatus,
  getDictionariesTargetEntityFounderStatus,
  getDictionariesDecisionKindsAllStatus,
  getDictionariesEventHasUnplannedActivityStatus,
  getFederalLawsStatus,
} from '../selectors/dictionariesSelectors';
import { IPairKnoSupervisionVersions } from '../interfaces/IPairKnoSupervisionVersions';
import { parseDictionaryVersionValue } from '../common/parseDictionaryVersionValue';
import { createDictionarySupervisionTypeExtendedSelectOption } from '../common/createDictionarySupervisionTypeSelectOption';
import { IDictionarySelectOption } from '../interfaces/IDictionarySelectOption';
import { getKnmSystemType } from '../../../KnmPackage/MainModule/selectors/knmSelectors';
import { IRootState } from '../../MainModule/interfaces/IRootState';
import { IControlWithDate } from '../../../APIPackage/DictionariesModule/interfaces/IControlWithDate';
import {
  getUserInfoKnoOrganisations,
  getUserInfoOrganisationsAdminLevelCode,
  getUserInfoOrganisationsPage,
  getUserInfoOrganisationsParentId,
  getUserInfoOrganisationsSearchQuery,
} from '../../../PersonalAccountPackage/UserInfoModule/selectors/userInfoSelectors';
import { getCatalogKnoAdminLevelsSelectOptions } from '../../CatalogsModule/selectors/catalogsSelectors';
import { userInfoSetOrganisations } from '../../../PersonalAccountPackage/UserInfoModule/actions/userInfoActions';
import { IKnoOrganisationsChildrenResponse } from '../../../APIPackage/CatalogsModule/interfaces/IKnoOrganisationsChildrenResponse';
import { fetchErvkCheckList } from '../../../APIPackage/CatalogsModule/services/ervkCheckListApi';
import { IErvkCheckList } from '../../../APIPackage/DictionariesModule/interfaces/IErvkCheckList';
import { KnmSystemTypesEnum } from '../../../KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import { ITripletKnoSupervisionCondition } from '../interfaces/ITripletKnoSupervisionCondition';
import { IKnmReasonType } from '../../../APIPackage/CatalogsModule/interfaces/IKnmReasonType';
import { fetchConditionTypesDictionary } from '../../../APIPackage/CatalogsModule/services/knmReasonTypesApi';
import { addNoticeAction } from '../../NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from '../../NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../../NotificationModule/enums/MessageTypesEnum';
import { createDictionarySubjectKindSelectOption } from '../common/createDictionarySubjectKindSelectOption';
import { createDictionaryPermitDocsSelectOption } from '../common/createDictionaryPermitDocsSelectOption';

export function* watchDictionariesSaga() {
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_KNO_SUPERVISION_GET, dictionariesKnoSupervisionGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_EVENT_UUID_GET, dictionariesEventUuidGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_EVENT_HAS_UNPLANNED_ACTIVITY_GET,
    dictionariesEventHasUnplannedActivityHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_GET, dictionariesGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUES_GET, dictionaryValuesGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET, dictionaryValueGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_WITH_CALLBACK,
    dictionariesItemValueGetWithCallbackHandler,
  );
  yield takeEvery(DictionariesActionsEnum.SUPERVISION_DICTIONARY_VALUE_GET, supervisionDictionaryValueGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_GET,
    dictionariesKnoOrganizationsItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_KNO_ORGANIZATIONS_ITEM_UPDATE,
    dictionariesKnoOrganizationsItemUpdateHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_POSITIONS_ITEM_GET, dictionariesPositionsItemGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_PERMIT_DOCS_ITEM_GET, dictionariesPermitDocsItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_PARTICIPANT_POSITIONS_ITEM_GET,
    dictionariesParticipantPositionsItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_KNM_KIND_ITEM_GET, dictionariesKnmKindsItemGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ITEM_GET, dictionariesDecisionKindsItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_DECISION_KIND_ALL_ITEM_GET,
    dictionariesDecisionKindsAllItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_PROF_KIND_ITEM_GET, dictionariesProfKindsItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET,
    dictionariesRiskCategoriesItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_RISK_CATEGORY_ITEM_GET_UPDATE,
    dictionariesRiskCategoriesItemUpdateHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_DANGER_CLASS_ITEM_GET, dictionariesDangerClassesItemGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_ITEM_GET, dictionariesSubjectTypesItemGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_ITEM_GET, dictionariesSubjectKindsItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_ITEM_GET,
    dictionariesSubjectSubKindsItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET, fetchFederalLawsSaga);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_APPLICATION_CONDITION_SUBJECTS_ITEM_GET,
    dictionariesApplicationConditionSubjectsItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_EVENT_TYPE_ITEM_GET, dictionariesEventTypesItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_PM_PROF_EVENT_TYPE_ITEM_GET,
    dictionariesPmProfEventTypesItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_ITEM_GET,
    dictionariesSupervisionTypesItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUPERVISION_TYPE_BY_SUBJECT_TYPE_ITEM_GET,
    dictionariesSupervisionTypesBySubjectTypeItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_ACCEPTED_DOCUMENT_ITEM_GET,
    dictionariesAcceptedDocumentsItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.ERVK_CHECK_LIST_GET, dictionariesErvkCheckListGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_CHECKLIST_ITEM_GET, dictionariesChecklistsItemGetHandler);
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_REQUIREMENT_ITEM_GET, dictionariesRequirementsItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_RISK_INDICATORY_ITEM_GET,
    dictionariesRiskIndicatorsItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_ITEM_GET, dictionariesTargetEntityItemGetHandler);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_TARGET_ENTITY_FOUNDER_ITEM_GET,
    dictionariesTargetEntityFounderItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUBJECT_TYPE_MULTI_ITEM_GET,
    dictionariesSubjectTypesMultiItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUBJECT_KIND_MULTI_ITEM_GET,
    dictionariesSubjectKindsMultiItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_SUBJECT_SUB_KIND_MULTI_ITEM_GET,
    dictionariesSubjectSubKindsMultiItemGetHandler,
  );
  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_KNO_ORGANISATIONS_GET, dictionariesKnoOrganisationsGetSaga);
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_KNO_ORGANISATIONS_GET_NEXT_PAGE,
    dictionariesKnoOrganisationsGetNextPageSaga,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_CONDITION_TYPES_ITEM_GET,
    dictionariesConditionTypesItemGetHandler,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_FIND_SUBJECT_KIND_SELECT_OPTIONS_BY_QUERY,
    dictionariesFindSubjectKindSelectOptionsByQuerySaga,
  );
  yield takeEvery(
    DictionariesActionsEnum.DICTIONARIES_FIND_SUBJECT_SUB_KIND_SELECT_OPTIONS_BY_QUERY,
    dictionariesFindSubjectSubKindSelectOptionsByQuerySaga,
  );
  yield takeLatest(
    DictionariesActionsEnum.DICTIONARIES_GET_DOC_TARGET_SELECT_OPTIONS_BY_QUERY,
    dictionariesGetDocTargetSelectOptionsSaga,
  );

  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_FEDERAL_LAWS_GET, fetchFederalLawsSaga);

  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_KNM_SUBJECT_TYPES_GET, fetchKnmSubjectTypesSaga);

  yield takeEvery(DictionariesActionsEnum.DICTIONARIES_FILTERED_FEDERAL_LAWS_GET, fetchFilteredFederalLawsSaga);
}

function* dictionariesKnoSupervisionGetHandler(action: ActionType<typeof dictionariesKnoSupervisionGet>) {
  const { knoVersionId, supervisionVersionId } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesKnoSupervisionStatus,
    knoVersionId,
    supervisionVersionId,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionariesKnoSupervisionSaga(knoVersionId, supervisionVersionId);
  }
}

function* fetchDictionariesKnoSupervisionSaga(knoVersionId: string, supervisionVersionId: string) {
  function* funcTry() {
    yield put(dictionariesKnoSupervisionGetRequest(knoVersionId, supervisionVersionId));
    const data: IControlWithDate = yield fetchDictionaryKnoSupervision(knoVersionId, supervisionVersionId);

    yield put(dictionariesKnoSupervisionGetSuccess(data, knoVersionId, supervisionVersionId));
  }
  function* funcCatch() {
    yield put(dictionariesKnoSupervisionGetFailure(knoVersionId, supervisionVersionId));
    yield put(
      addNoticeAction({
        noticeType: NoticeTypesEnum.ERROR,
        messageType: MessageTypesEnum.GET_KNO_SUPERVISION,
        renderContent: 'Не удалось найти связку КНО + ВК в базе данных',
      }),
    );
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesEventUuidGetHandler(action: ActionType<typeof dictionariesEventUuidGet>) {
  const { knoVersionId, supervisionVersionId, knmKindVersionId } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesEventUuidStatus,
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionariesEventUuidSaga(knoVersionId, supervisionVersionId, knmKindVersionId);
  }
}

function* fetchDictionariesEventUuidSaga(knoVersionId: string, supervisionVersionId: string, knmKindVersionId: string) {
  function* funcTry() {
    yield put(dictionariesEventUuidGetRequest(knoVersionId, supervisionVersionId, knmKindVersionId));
    const eventUuid: string[] = yield fetchGetEventUuid(knoVersionId, supervisionVersionId, knmKindVersionId);

    yield put(dictionariesEventUuidGetSuccess(eventUuid, knoVersionId, supervisionVersionId, knmKindVersionId));
  }
  function* funcCatch() {
    yield put(dictionariesEventUuidGetFailure(knoVersionId, supervisionVersionId, knmKindVersionId));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesEventHasUnplannedActivityHandler(
  action: ActionType<typeof dictionariesEventHasUnplannedActivityGet>,
) {
  const { knoVersionId, supervisionVersionId, knmKindVersionId } = action.payload;

  const status: DictionaryStatusesEnum = yield select(
    getDictionariesEventHasUnplannedActivityStatus,
    knoVersionId,
    supervisionVersionId,
    knmKindVersionId,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionariesEventHasUnplannedActivitySaga(knoVersionId, supervisionVersionId, knmKindVersionId);
  }
}

function* fetchDictionariesEventHasUnplannedActivitySaga(
  knoVersionId: string,
  supervisionVersionId: string,
  knmKindVersionId: string,
) {
  function* funcTry() {
    yield put(dictionariesEventHasUnplannedActivityGetRequest(knoVersionId, supervisionVersionId, knmKindVersionId));
    const hasUnplannedActivity: boolean = yield fetchGetEventHasUnplannedActivity(
      knoVersionId,
      supervisionVersionId,
      knmKindVersionId,
    );

    yield put(
      dictionariesEventHasUnplannedActivityGetSuccess(
        hasUnplannedActivity,
        knoVersionId,
        supervisionVersionId,
        knmKindVersionId,
      ),
    );
  }

  function* funcCatch() {
    yield put(dictionariesEventHasUnplannedActivityGetFailure(knoVersionId, supervisionVersionId, knmKindVersionId));
  }

  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesGetHandler() {
  const status: DictionaryStatusesEnum = yield select(getDictionariesItemsListStatus);

  if (status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionariesSaga();
  }
}

function* fetchDictionariesSaga() {
  function* funcTry() {
    yield put(dictionariesGetRequest());
    const allDictionaries: IDictionary[] = yield fetchAllDictionaries();

    yield put(dictionariesGetSuccess(allDictionaries));
  }
  function* funcCatch() {
    yield put(dictionariesGetFailure());
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionaryValuesGetHandler(action: ActionType<typeof dictionariesItemValuesGet>) {
  const { dictionaryName } = action.payload;
  const status: DictionaryStatusesEnum = yield select(makeGetDictionaryValuesStatus(dictionaryName));

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionaryValuesSaga(dictionaryName);
  }
}

function* fetchDictionaryValuesSaga(dictionaryName: DictionaryNamesEnum) {
  function* funcTry() {
    yield put(dictionariesItemValuesGetRequest(dictionaryName));
    const id = dictionaryIdByName[dictionaryName];
    const dictionaryValues: IDictionaryVersion[] = yield fetchDictionaryValues(id, -1);

    yield put(dictionariesItemValuesGetSuccess(dictionaryName, dictionaryValues));
  }
  function* funcCatch() {
    yield put(dictionariesItemValuesGetFailure(dictionaryName));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionaryValueGetHandler(action: ActionType<typeof dictionariesItemValueGet>) {
  const { dictionaryUUID, dictionaryVersionUUID } = action.payload;
  const status: DictionaryStatusesEnum | undefined = yield select(
    getDictionariesItemValueStatus,
    dictionaryUUID,
    dictionaryVersionUUID,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDictionaryValueSaga(dictionaryUUID, dictionaryVersionUUID);
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    yield put(dictionariesItemValueGetAlreadyLoad(dictionaryUUID, dictionaryVersionUUID));
  }
}

function* fetchDictionaryValueSaga(dictionaryUUID: DictionaryUUIDsEnum, dictionaryVersionUUID: string) {
  function* funcTry() {
    yield put(dictionariesItemValueGetRequest(dictionaryUUID, dictionaryVersionUUID));
    const dictionaryVersion: IDictionaryVersion = yield fetchDictionaryValue(dictionaryUUID, dictionaryVersionUUID);

    if (!dictionaryVersion) {
      yield put(dictionariesItemValueGetNoData(dictionaryUUID, dictionaryVersionUUID));

      return;
    }

    const dictionaryValue: IDictionaryValue<IDictionaryValueTypeById[typeof dictionaryUUID]> = {
      idValue: dictionaryVersion.id,
      value: parseDictionaryVersionValue<IDictionaryValueTypeById[typeof dictionaryUUID]>(dictionaryVersion),
    };

    yield put(dictionariesItemValueGetSuccess(dictionaryUUID, dictionaryVersionUUID, dictionaryValue));
  }
  function* funcCatch() {
    yield put(dictionariesItemValueGetFailure(dictionaryUUID, dictionaryVersionUUID));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesItemValueGetWithCallbackHandler(action: ActionType<typeof dictionariesItemValueGetWithCallback>) {
  const { dictionaryUUID, dictionaryVersionUUID, callbackAction } = action.payload;
  const status: DictionaryStatusesEnum | undefined = yield select(
    getDictionariesItemValueStatus,
    dictionaryUUID,
    dictionaryVersionUUID,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield put(dictionariesItemValueGetRequestWithCallback(dictionaryUUID, dictionaryVersionUUID));
    yield fetchDictionaryValueWithCallbackSaga(dictionaryUUID, dictionaryVersionUUID, callbackAction);
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    const value: IDictionaryValue<IDictionaryValueTypeById[typeof dictionaryUUID]> = yield select(
      getDictionariesItemValueData,
      dictionaryUUID,
      dictionaryVersionUUID,
    );

    yield put(createAction(callbackAction, { value }));
  } else if (status === DictionaryStatusesEnum.LOADING) {
    while (true) {
      const actionRes: ActionType<typeof dictionariesItemValueGetSuccessWithCallback> = yield take([
        DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS_WITH_CALLBACK,
        DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_FAILURE_WITH_CALLBACK,
        DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS,
        DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_FAILURE,
        DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_NO_DATA,
      ]);

      if (
        actionRes.payload.dictionaryUUID === action.payload.dictionaryUUID &&
        actionRes.payload.dictionaryVersionUUID === action.payload.dictionaryVersionUUID
      ) {
        if (
          actionRes.type === DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS_WITH_CALLBACK ||
          actionRes.type === DictionariesActionsEnum.DICTIONARIES_ITEM_VALUE_GET_SUCCESS
        ) {
          yield put(createAction(callbackAction, { value: actionRes.payload.data }));
        }
        break;
      }
    }
  }
}

function* fetchDictionaryValueWithCallbackSaga(
  dictionaryUUID: DictionaryUUIDsEnum,
  dictionaryVersionUUID: string,
  callbackAction: string,
) {
  function* funcTry() {
    const dictionaryVersion: IDictionaryVersion = yield fetchDictionaryValue(dictionaryUUID, dictionaryVersionUUID);

    if (!dictionaryVersion) {
      yield put(dictionariesItemValueGetNoData(dictionaryUUID, dictionaryVersionUUID));
      yield put(createAction(callbackAction, { value: undefined }));

      return;
    }

    const dictionaryValue: IDictionaryValue<IDictionaryValueTypeById[typeof dictionaryUUID]> = {
      idValue: dictionaryVersion.id,
      value: parseDictionaryVersionValue<IDictionaryValueTypeById[typeof dictionaryUUID]>(dictionaryVersion),
    };

    yield put(dictionariesItemValueGetSuccessWithCallback(dictionaryUUID, dictionaryVersionUUID, dictionaryValue));
    yield put(createAction(callbackAction, { value: dictionaryValue }));
  }
  function* funcCatch() {
    yield put(dictionariesItemValueGetFailureWithCallback(dictionaryUUID, dictionaryVersionUUID));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesKnoOrganizationsItemGetHandler() {
  const status: DictionaryStatusesEnum = yield select(getDictionariesKnoOrganizationsStatus);

  if (status === DictionaryStatusesEnum.IDLE) {
    yield fetchKnoOrganizationsDictionarySaga();
  }
}

function* dictionariesKnoOrganizationsItemUpdateHandler() {
  yield fetchKnoOrganizationsDictionarySaga();
}

function* dictionariesPositionsItemGetHandler(action: ActionType<typeof dictionariesPositionsItemGet>) {
  const { knoSupervisionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesPositionsStatus, knoSupervisionUuid);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchPositionsDictionarySaga(knoSupervisionUuid);
  }
}

/**
 * Получение списка разрешительных документов через id вида контроля
 */
function* dictionariesPermitDocsItemGetHandler(action: ActionType<typeof dictionariesPermitDocsItemGet>) {
  const { controlKindUuid, uuidKno } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesPermitDocsStatus, controlKindUuid);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchPermitDocsDictionarySaga(controlKindUuid, uuidKno);
  }
}

function* dictionariesParticipantPositionsItemGetHandler(
  action: ActionType<typeof dictionariesParticipantPositionsItemGet>,
) {
  const { knoSupervisionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesParticipantPositionsStatus, knoSupervisionUuid);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchParticipantPositionsDictionarySaga(knoSupervisionUuid);
  }
}

function* dictionariesKnmKindsItemGetHandler(action: ActionType<typeof dictionariesKnmKindsItemGet>) {
  const { triplet } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesKnmKindsStatus, triplet);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchKnmKindsDictionarySaga(triplet);
  }
}

function* dictionariesDecisionKindsItemGetHandler(action: ActionType<typeof dictionariesDecisionKindsItemGet>) {
  const { pair } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesKnmKindsStatus, pair);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDecisionKindsDictionarySaga(pair);
  }
}

function* dictionariesDecisionKindsAllItemGetHandler(action: ActionType<typeof dictionariesDecisionKindsAllItemGet>) {
  const { pair } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesDecisionKindsAllStatus, pair);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDecisionKindsAllDictionarySaga(pair);
  }
}

function* dictionariesProfKindsItemGetHandler(action: ActionType<typeof dictionariesProfKindsItemGet>) {
  const { pair, conditionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesProfKindsStatus, pair, conditionUuid);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchProfKindsDictionarySaga(pair, conditionUuid);
  }
}

function* dictionariesAcceptedDocumentsItemGetHandler(action: ActionType<typeof dictionariesAcceptedDocumentsItemGet>) {
  const { pair } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesAcceptedDocumentsStatus, pair);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchAcceptedDocumentsDictionarySaga(pair);
  }
}

function* dictionariesRiskCategoriesItemGetHandler(action: ActionType<typeof dictionariesRiskCategoriesItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid, knmKindUuid, isPlanned } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesRiskCategoriesStatus,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    knmKindUuid,
    isPlanned,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchRiskCategoriesDictionarySaga(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      knmKindUuid,
      isPlanned,
    );
  }
}

function* dictionariesRiskCategoriesItemUpdateHandler(action: ActionType<typeof dictionariesRiskCategoriesItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid, knmKindUuid, isPlanned } = action.payload;

  yield fetchRiskCategoriesDictionarySaga(knoSupervisionUuid, conditionUuid, orderVersionUuid, knmKindUuid, isPlanned);
}

function* dictionariesDangerClassesItemGetHandler(action: ActionType<typeof dictionariesDangerClassesItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid, isPlanned } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesDangerClassesStatus,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    isPlanned,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchDangerClassesDictionarySaga(knoSupervisionUuid, conditionUuid, orderVersionUuid, isPlanned);
  }
}

function* dictionariesSubjectTypesItemGetHandler(action: ActionType<typeof dictionariesSubjectTypesItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectTypesStatus,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectTypesDictionarySaga(knoSupervisionUuid, conditionUuid, orderVersionUuid);
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    // При кэше повторно шлём SUCCESS, чтобы UI/саги подхватили уже загруженный справочник «Тип объекта»
    const data: ReturnType<typeof getDictionariesSubjectTypesData> = yield select(
      getDictionariesSubjectTypesData,
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
    );

    if (data) {
      yield put(dictionariesSubjectTypesItemGetSuccess(data, knoSupervisionUuid, conditionUuid, orderVersionUuid));
    }
  }
}

function* dictionariesSubjectKindsItemGetHandler(action: ActionType<typeof dictionariesSubjectKindsItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid, objectTypeDictVersionId } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectKindsStatus,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectKindsDictionarySaga(knoSupervisionUuid, conditionUuid, orderVersionUuid, objectTypeDictVersionId);
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    const data: ReturnType<typeof getDictionariesSubjectKindsData> = yield select(
      getDictionariesSubjectKindsData,
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      objectTypeDictVersionId,
    );

    if (data) {
      yield put(
        dictionariesSubjectKindsItemGetSuccess(
          data,
          knoSupervisionUuid,
          conditionUuid,
          orderVersionUuid,
          objectTypeDictVersionId,
        ),
      );
    }
  }
}

function* dictionariesSubjectSubKindsItemGetHandler(action: ActionType<typeof dictionariesSubjectSubKindsItemGet>) {
  const { knoSupervisionUuid, conditionUuid, orderVersionUuid, objectTypeDictVersionId } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectSubKindsStatus,
    knoSupervisionUuid,
    conditionUuid,
    orderVersionUuid,
    objectTypeDictVersionId,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectSubKindsDictionarySaga(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      objectTypeDictVersionId,
    );
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    const data: ReturnType<typeof getDictionariesSubjectSubKindsData> = yield select(
      getDictionariesSubjectSubKindsData,
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      objectTypeDictVersionId,
    );

    if (data) {
      yield put(
        dictionariesSubjectSubKindsItemGetSuccess(
          data,
          knoSupervisionUuid,
          conditionUuid,
          orderVersionUuid,
          objectTypeDictVersionId,
        ),
      );
    }
  }
}

function* dictionariesApplicationConditionSubjectsItemGetHandler(
  action: ActionType<typeof dictionariesSubjectSubKindsItemGet>,
) {
  const { conditionUuid, orderVersionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesApplicationConditionSubjectsStatus,
    conditionUuid,
    orderVersionUuid,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchApplicationConditionSubjectsDictionarySaga(conditionUuid, orderVersionUuid);
  }
}

function* dictionariesEventTypesItemGetHandler(action: ActionType<typeof dictionariesEventTypesItemGet>) {
  const { uniqueUuid, conditionUuid, isPm, orderVersionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesEventTypesStatus,
    uniqueUuid,
    conditionUuid,
    orderVersionUuid,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchEventTypesDictionarySaga(isPm, uniqueUuid, conditionUuid, orderVersionUuid);
  }
}

function* dictionariesPmProfEventTypesItemGetHandler(action: ActionType<typeof dictionariesPmProfEventTypesItemGet>) {
  const { isUnableToRefuse } = action.payload;
  const status: DictionaryStatusesEnum = yield select(state =>
    getDictionariesPmProfEventTypesStatus(state, isUnableToRefuse),
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchPmProfEventTypesDictionarySaga(isUnableToRefuse);
  }
}

function* dictionariesSupervisionTypesItemGetHandler(action: ActionType<typeof dictionariesSupervisionTypesItemGet>) {
  const { filterUUIDs, isPlanned, federalLawUUIDs } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSupervisionTypesStatus,
    filterUUIDs,
    isPlanned,
    federalLawUUIDs,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSupervisionTypesDictionarySaga(filterUUIDs, isPlanned, federalLawUUIDs);
  }
}

function* dictionariesSupervisionTypesBySubjectTypeItemGetHandler(
  action: ActionType<typeof dictionariesSupervisionTypesBySubjectTypeItemGet>,
) {
  const { subjectTypeUuid } = action.payload;

  yield dictionariesSupervisionTypeBySubjectTypeGetHandlerWithReturnOptions(subjectTypeUuid);
}

export function* dictionariesSupervisionTypesItemGetHandlerWithReturnOptions(ids: string[]) {
  const status: DictionaryStatusesEnum = yield select(getDictionariesSupervisionTypesStatus, ids, true);
  let selectOption: IDictionarySelectOption<ISupervisionType>[] = [];

  function* funcTry() {
    if (!status || status === DictionaryStatusesEnum.IDLE) {
      yield put(dictionariesSupervisionTypesItemGetRequest(ids, true));
      const dictionaryValue: IDictionaryValues<ISupervisionType> = yield fetchSupervisionTypesDictionary(
        ids,
        true,
        undefined,
      );

      yield put(dictionariesSupervisionTypesItemGetSuccess(dictionaryValue, ids, true));

      selectOption = dictionaryValue.values.map(item =>
        createDictionarySupervisionTypeExtendedSelectOption(dictionaryValue.idDictionary, item, false),
      );
    }
  }

  function* funcCatch() {
    yield put(dictionariesSupervisionTypesItemGetFailure(ids, true));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });

  return selectOption;
}

function* dictionariesSupervisionTypeBySubjectTypeGetHandlerWithReturnOptions(subjectTypeUuid: string) {
  let selectOption: IDictionarySelectOption<ISupervisionType>[] = [];

  function* funcTry() {
    yield put(dictionariesSupervisionTypesBySubjectTypeItemGetRequest(subjectTypeUuid));
    const dictionaryValue: IDictionaryValues<ISupervisionType> = yield fetchSupervisionTypeBySubjectTypeDictionary(
      subjectTypeUuid,
    );

    yield put(dictionariesSupervisionTypesBySubjectTypeItemGetSuccess(dictionaryValue, subjectTypeUuid));

    selectOption = dictionaryValue.values.map(item =>
      createDictionarySupervisionTypeExtendedSelectOption(dictionaryValue.idDictionary, item, false),
    );
  }

  function* funcCatch() {
    yield put(dictionariesSupervisionTypesBySubjectTypeItemGetFailure(subjectTypeUuid));
  }

  yield sagaWrapper({
    funcTry,
    funcCatch,
  });

  return selectOption;
}

function* dictionariesChecklistsItemGetHandler(action: ActionType<typeof dictionariesChecklistsItemGet>) {
  const { filterParams } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesChecklistsStatus, filterParams);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchChecklistsDictionarySaga(filterParams);
  }
}

function* dictionariesRequirementsItemGetHandler(action: ActionType<typeof dictionariesRequirementsItemGet>) {
  const { filterParams } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesRequirementsStatus, filterParams);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchRequirementsDictionarySaga(filterParams);
  }
}

function* dictionariesRiskIndicatorsItemGetHandler(action: ActionType<typeof dictionariesRiskIndicatorsItemGet>) {
  const { knoSupervisionUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesRiskIndicatorsStatus, knoSupervisionUuid);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchRiskIndicatorsDictionarySaga(knoSupervisionUuid);
  }
}

function* dictionariesTargetEntityItemGetHandler(action: ActionType<typeof dictionariesTargetEntityItemGet>) {
  const { triplet } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesTargetEntityStatus, triplet);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchTargetEntityDictionarySaga(triplet);
  }
}

function* dictionariesTargetEntityFounderItemGetHandler() {
  const status: DictionaryStatusesEnum = yield select(getDictionariesTargetEntityFounderStatus);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchTargetEntityFounderDictionarySaga();
  }
}

function* dictionariesSubjectTypesMultiItemGetHandler(action: ActionType<typeof dictionariesSubjectTypesMultiItemGet>) {
  const { knoVersionIds, supervisionVersionIds } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectTypesMultiStatus,
    knoVersionIds,
    supervisionVersionIds,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectTypesMultiDictionarySaga(knoVersionIds, supervisionVersionIds);
  }
}

function* dictionariesSubjectKindsMultiItemGetHandler(action: ActionType<typeof dictionariesSubjectKindsMultiItemGet>) {
  const { knoVersionIds, supervisionVersionIds } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectKindsMultiStatus,
    knoVersionIds,
    supervisionVersionIds,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectKindsMultiDictionarySaga(knoVersionIds, supervisionVersionIds);
  }
}

function* dictionariesSubjectSubKindsMultiItemGetHandler(
  action: ActionType<typeof dictionariesSubjectSubKindsMultiItemGet>,
) {
  const { knoVersionIds, supervisionVersionIds } = action.payload;
  const status: DictionaryStatusesEnum = yield select(
    getDictionariesSubjectSubKindsMultiStatus,
    knoVersionIds,
    supervisionVersionIds,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSubjectSubKindsMultiDictionarySaga(knoVersionIds, supervisionVersionIds);
  }
}

function* dictionariesConditionTypesItemGetHandler(action: ActionType<typeof dictionariesConditionTypesItemGet>) {
  const { uniqueUuid } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getDictionariesConditionTypesStatus, uniqueUuid);

  if ((!status || status === DictionaryStatusesEnum.IDLE) && uniqueUuid !== KnmSystemTypesEnum.ERP) {
    yield fetchConditionTypesDictionarySaga(uniqueUuid);
  }
}

function* fetchKnmSubjectTypesSaga() {
  const status: DictionaryStatusesEnum = yield select(getKnmSubjectTypesStatus);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield put(dictionariesKnmSubjectTypesGetRequest());

    try {
      const rawData: { id: number; value: string }[] = yield fetchDictionaryValues(
        DictionaryUUIDsEnum.KNM_SUBJECT_TYPES,
        -1,
      );

      const parsedData = rawData.map(item => ({
        idValue: String(item.id),
        value: JSON.parse(item.value) as IKnmSubjectTypesERVK,
      }));

      const dictionaryValue: IDictionaryValues<IKnmSubjectTypesERVK> = {
        idDictionary: DictionaryUUIDsEnum.KNM_SUBJECT_TYPES,
        values: parsedData,
      };

      yield put(dictionariesKnmSubjectTypesGetSuccess(dictionaryValue));
    } catch (error) {
      console.error('Failed to fetch knm subject types:', error);
      yield put(dictionariesKnmSubjectTypesGetFailure());
    }
  }
}

function* fetchKnoOrganizationsDictionarySaga() {
  function* funcTry() {
    yield put(dictionariesKnoOrganizationsItemGetRequest());
    const dictionaryValue: IDictionaryValues<IKnoOrganizationDictionary> = yield fetchKnoOrganizationsDictionary();

    yield put(dictionariesKnoOrganizationsItemGetSuccess(dictionaryValue));
  }
  function* funcCatch() {
    yield put(dictionariesKnoOrganizationsItemGetFailure());
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchPositionsDictionarySaga(knoSupervisionUuid?: string) {
  function* funcTry() {
    yield put(dictionariesPositionsItemGetRequest(knoSupervisionUuid));
    const dictionaryValue: IDictionaryValues<IPosition> = yield fetchPositionsDictionary(knoSupervisionUuid);

    yield put(dictionariesPositionsItemGetSuccess(dictionaryValue, knoSupervisionUuid));
  }
  function* funcCatch() {
    yield put(dictionariesPositionsItemGetFailure(knoSupervisionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

/**
 * Получение списка разрешительных документов через id вида контроля
 */
function* fetchPermitDocsDictionarySaga(controlKindUuid?: string, uuidKno?: string) {
  function* funcTry() {
    yield put(dictionariesPermitDocsItemGetRequest(controlKindUuid, uuidKno));
    const dictionaryValue: IPermitDocs[] = yield fetchPermitDocsDictionary(controlKindUuid, uuidKno);

    yield put(dictionariesPermitDocsItemGetSuccess(dictionaryValue, controlKindUuid, uuidKno));
  }
  function* funcCatch() {
    yield put(dictionariesPermitDocsItemGetFailure(controlKindUuid, uuidKno));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchParticipantPositionsDictionarySaga(knoSupervisionUuid?: string) {
  function* funcTry() {
    yield put(dictionariesParticipantPositionsItemGetRequest(knoSupervisionUuid));
    const dictionaryValue: IDictionaryValues<IParticipantPosition> = yield fetchParticipantPositionsDictionary(
      knoSupervisionUuid,
    );

    yield put(dictionariesParticipantPositionsItemGetSuccess(dictionaryValue, knoSupervisionUuid));
    const state: IRootState = yield select();

    if (getKnmSystemType(state) === KnmSystemTypesEnum.PM) {
      yield put(
        // @ts-ignore
        dictionariesItemValueGetSuccess(dictionaryValue.idDictionary, knoSupervisionUuid || '', dictionaryValue),
      );
    }
  }
  function* funcCatch() {
    yield put(dictionariesParticipantPositionsItemGetFailure(knoSupervisionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchKnmKindsDictionarySaga(triplet?: ITripletKnoSupervisionCondition) {
  function* funcTry() {
    yield put(dictionariesKnmKindsItemGetRequest(triplet));
    const dictionaryValue: IDictionaryValues<IKnmKind> = yield fetchKnmKindsDictionary(
      triplet?.knoVersionId,
      triplet?.supervisionVersionId,
      triplet?.conditionUuid,
    );

    yield put(dictionariesKnmKindsItemGetSuccess(dictionaryValue, triplet));
  }
  function* funcCatch() {
    yield put(dictionariesKnmKindsItemGetFailure(triplet));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchDecisionKindsDictionarySaga(pair?: IPairKnoSupervisionVersions) {
  function* funcTry() {
    yield put(dictionariesDecisionKindsItemGetRequest(pair));
    const dictionaryValue: IDictionaryValues<IDecisionKind> = yield fetchGetDecisionKindsDictionary(
      pair?.knoVersionId,
      pair?.supervisionVersionId,
    );

    yield put(dictionariesDecisionKindsItemGetSuccess(dictionaryValue, pair));
  }
  function* funcCatch() {
    yield put(dictionariesDecisionKindsItemGetFailure(pair));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchDecisionKindsAllDictionarySaga(pair?: IPairKnoSupervisionVersions) {
  function* funcTry() {
    yield put(dictionariesDecisionKindsAllItemGetRequest(pair));
    const dictionaryValue: IDictionaryValues<IDecisionKind> = yield fetchGetDecisionKindsAllDictionary(
      pair?.knoVersionId,
      pair?.supervisionVersionId,
    );

    yield put(dictionariesDecisionKindsAllItemGetSuccess(dictionaryValue, pair));
  }
  function* funcCatch() {
    yield put(dictionariesDecisionKindsAllItemGetFailure(pair));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchProfKindsDictionarySaga(pair?: IPairKnoSupervisionVersions, conditionUuid?: string) {
  function* funcTry() {
    yield put(dictionariesProfKindsItemGetRequest(pair, conditionUuid));
    const dictionaryValue: IDictionaryValues<IProfKind> = yield fetchProfKindsDictionary(
      pair?.knoVersionId,
      pair?.supervisionVersionId,
      conditionUuid,
    );

    yield put(dictionariesProfKindsItemGetSuccess(dictionaryValue, pair, conditionUuid));
  }
  function* funcCatch() {
    yield put(dictionariesProfKindsItemGetFailure(pair, conditionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRiskCategoriesDictionarySaga(
  knoSupervisionUuid: string | undefined,
  conditionUuid: string | undefined,
  orderVersionUuid: string | undefined,
  knmKindUuid: string | undefined,
  isPlanned: boolean | undefined,
) {
  function* funcTry() {
    yield put(
      dictionariesRiskCategoriesItemGetRequest(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        knmKindUuid,
        isPlanned,
      ),
    );
    const dictionaryValue: IDictionaryValues<IRiskCategory248> = yield fetchRiskCategoriesDictionary(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      knmKindUuid,
      isPlanned,
    );

    yield put(
      dictionariesRiskCategoriesItemGetSuccess(
        dictionaryValue,
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        knmKindUuid,
        isPlanned,
      ),
    );
  }
  function* funcCatch() {
    yield put(
      dictionariesRiskCategoriesItemGetFailure(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        knmKindUuid,
        isPlanned,
      ),
    );
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchDangerClassesDictionarySaga(
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  isPlanned?: boolean,
) {
  function* funcTry() {
    yield put(dictionariesDangerClassesItemGetRequest(knoSupervisionUuid, conditionUuid, orderVersionUuid, isPlanned));
    const dictionaryValue: IDictionaryValues<IDangerClass248> = yield fetchDangerClassesDictionary(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      isPlanned,
    );

    yield put(
      dictionariesDangerClassesItemGetSuccess(
        dictionaryValue,
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        isPlanned,
      ),
    );
  }
  function* funcCatch() {
    yield put(dictionariesDangerClassesItemGetFailure(knoSupervisionUuid, conditionUuid, orderVersionUuid, isPlanned));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectTypesDictionarySaga(
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) {
  function* funcTry() {
    yield put(dictionariesSubjectTypesItemGetRequest(knoSupervisionUuid, conditionUuid, orderVersionUuid));
    const dictionaryValue: IDictionaryValues<ISubjectType> = yield fetchSubjectTypesDictionary(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
    );

    yield put(
      dictionariesSubjectTypesItemGetSuccess(dictionaryValue, knoSupervisionUuid, conditionUuid, orderVersionUuid),
    );
  }
  function* funcCatch() {
    yield put(dictionariesSubjectTypesItemGetFailure(knoSupervisionUuid, conditionUuid, orderVersionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectKindsDictionarySaga(
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) {
  function* funcTry() {
    yield put(
      dictionariesSubjectKindsItemGetRequest(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
    const dictionaryValue: IDictionaryValues<ISubjectKind> = yield fetchSubjectKindsDictionary(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      objectTypeDictVersionId,
    );

    yield put(
      dictionariesSubjectKindsItemGetSuccess(
        dictionaryValue,
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
  }
  function* funcCatch() {
    yield put(
      dictionariesSubjectKindsItemGetFailure(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectSubKindsDictionarySaga(
  knoSupervisionUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
  objectTypeDictVersionId?: string,
) {
  function* funcTry() {
    yield put(
      dictionariesSubjectSubKindsItemGetRequest(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
    const dictionaryValue: IDictionaryValues<ISubjectType> = yield fetchSubjectSubKindsDictionary(
      knoSupervisionUuid,
      conditionUuid,
      orderVersionUuid,
      objectTypeDictVersionId,
    );

    yield put(
      dictionariesSubjectSubKindsItemGetSuccess(
        dictionaryValue,
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
  }
  function* funcCatch() {
    yield put(
      dictionariesSubjectSubKindsItemGetFailure(
        knoSupervisionUuid,
        conditionUuid,
        orderVersionUuid,
        objectTypeDictVersionId,
      ),
    );
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchEventTypesDictionarySaga(
  isPm?: boolean,
  uniqueUuid?: string,
  conditionUuid?: string,
  orderVersionUuid?: string,
) {
  function* funcTry() {
    yield put(dictionariesEventTypesItemGetRequest(uniqueUuid, conditionUuid, orderVersionUuid));

    const fetchFn = isPm
      ? fetchPmEventTypesDictionary.bind(null, uniqueUuid)
      : fetchEventTypesDictionary.bind(null, uniqueUuid, conditionUuid, orderVersionUuid);

    const dictionaryValue: IDictionaryValues<IEventType> = yield fetchFn();

    yield put(dictionariesEventTypesItemGetSuccess(dictionaryValue, uniqueUuid, conditionUuid, orderVersionUuid));
  }
  function* funcCatch() {
    yield put(dictionariesEventTypesItemGetFailure(uniqueUuid, conditionUuid, orderVersionUuid));
    if (!uniqueUuid) {
      yield put(
        addNoticeAction({
          renderContent: 'Пара версия ВК + вид мероприятия с идентификатором null не найдена',
          noticeType: NoticeTypesEnum.WARNING,
          messageType: MessageTypesEnum.ERKNM_GET_EVENT_TYPES,
        }),
      );
    }
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchPmProfEventTypesDictionarySaga(isUnableToRefuse?: boolean) {
  function* funcTry() {
    yield put(dictionariesPmProfEventTypesItemGetRequest(isUnableToRefuse));

    const dictionaryValue: IDictionaryValues<IEventType> = yield fetchPmProfEventTypesDictionary(isUnableToRefuse);

    yield put(dictionariesPmProfEventTypesItemGetSuccess(dictionaryValue, isUnableToRefuse));
  }
  function* funcCatch() {
    yield put(dictionariesPmProfEventTypesItemGetFailure(isUnableToRefuse));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSupervisionTypesDictionarySaga(uuids: string[], isPlanned: boolean, federalLawUUIDs?: string[]) {
  function* funcTry() {
    yield put(dictionariesSupervisionTypesItemGetRequest(uuids, isPlanned, federalLawUUIDs));
    const dictionaryValue: IDictionaryValues<ISupervisionType> = yield fetchSupervisionTypesDictionary(
      uuids,
      isPlanned,
      federalLawUUIDs,
    );

    yield put(dictionariesSupervisionTypesItemGetSuccess(dictionaryValue, uuids, isPlanned, federalLawUUIDs));
  }
  function* funcCatch() {
    yield put(dictionariesSupervisionTypesItemGetFailure(uuids, isPlanned, federalLawUUIDs));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchAcceptedDocumentsDictionarySaga(pair?: IPairKnoSupervisionVersions) {
  function* funcTry() {
    yield put(dictionariesAcceptedDocumentsItemGetRequest(pair));
    const dictionaryValue: IDictionaryValues<IAcceptedDocument> = yield fetchAcceptedDocumentsDictionary(
      pair?.knoVersionId,
      pair?.supervisionVersionId,
    );

    yield put(dictionariesAcceptedDocumentsItemGetSuccess(dictionaryValue, pair));
  }
  function* funcCatch() {
    yield put(dictionariesAcceptedDocumentsItemGetFailure(pair));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchChecklistsDictionarySaga(filterParams: { uuidKno: string; uuidSupervision: string }) {
  function* funcTry() {
    yield put(dictionariesChecklistsItemGetRequest(filterParams));
    const dictionaryValue: IDictionaryValues<IChecklistDictionary> = yield fetchChecklistsDictionary(
      filterParams.uuidKno,
      filterParams.uuidSupervision,
    );

    yield put(dictionariesChecklistsItemGetSuccess(dictionaryValue, filterParams));
  }
  function* funcCatch() {
    yield put(dictionariesChecklistsItemGetFailure(filterParams));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRequirementsDictionarySaga(filterParams: { uuidKno: string; uuidSupervision: string }) {
  function* funcTry() {
    yield put(dictionariesRequirementsItemGetRequest(filterParams));
    const dictionaryValue: IDictionaryValues<IRequirement> = yield fetchRequirementsDictionary(
      filterParams.uuidKno,
      filterParams.uuidSupervision,
    );

    yield put(dictionariesRequirementsItemGetSuccess(dictionaryValue, filterParams));
  }
  function* funcCatch() {
    yield put(dictionariesRequirementsItemGetFailure(filterParams));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesErvkCheckListGetHandler(action: ActionType<typeof dictionariesErvkCheckListGet>) {
  const { filterParams } = action.payload;
  const status: DictionaryStatusesEnum = yield select(getErvkCheckListStatus, filterParams);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchErvkCheckListSaga(filterParams);
  }
}

function* fetchErvkCheckListSaga(filterParams: IErvkListGetParams) {
  function* funcTry() {
    yield put(dictionariesErvkCheckListGetRequest(filterParams));
    const checklists: IErvkCheckList[] = yield fetchErvkCheckList(
      filterParams.controlKindId,
      filterParams.knmKindId,
      filterParams.subjectKindIds,
    );

    yield put(dictionariesErvkCheckListGetSuccess(checklists, filterParams));
  }
  function* funcCatch() {
    yield put(dictionariesErvkCheckListGetFailure(filterParams));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchRiskIndicatorsDictionarySaga(knoSupervisionUuid?: string) {
  function* funcTry() {
    yield put(dictionariesRiskIndicatorsItemGetRequest(knoSupervisionUuid));
    const dictionaryValue: IDictionaryValues<IRiskIndicatory> = yield fetchRiskIndicatorsDictionary(knoSupervisionUuid);

    yield put(dictionariesRiskIndicatorsItemGetSuccess(dictionaryValue, knoSupervisionUuid));
  }
  function* funcCatch() {
    yield put(dictionariesRiskIndicatorsItemGetFailure(knoSupervisionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchTargetEntityFounderDictionarySaga() {
  function* funcTry() {
    yield put(dictionariesTargetEntityFounderItemGetRequest());
    const dictionaryValue: IDictionaryValues<ITargetEntity> = yield fetchTargetEntityFounderDictionary();

    yield put(dictionariesTargetEntityFounderItemGetSuccess(dictionaryValue));
  }
  function* funcCatch() {
    yield put(dictionariesTargetEntityFounderItemGetFailure());
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchTargetEntityDictionarySaga(triplet?: ITripletKnoSupervisionCondition) {
  function* funcTry() {
    yield put(dictionariesTargetEntityItemGetRequest(triplet));
    const dictionaryValue: IDictionaryValues<ITargetEntity> = yield fetchTargetEntityDictionary(
      triplet?.knoVersionId,
      triplet?.supervisionVersionId,
      triplet?.conditionUuid,
      triplet?.orderVersionId,
    );

    yield put(dictionariesTargetEntityItemGetSuccess(dictionaryValue, triplet));
  }
  function* funcCatch() {
    yield put(dictionariesTargetEntityItemGetFailure(triplet));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectTypesMultiDictionarySaga(knoVersionIds: string[], supervisionVersionIds: string[]) {
  function* funcTry() {
    yield put(dictionariesSubjectTypesMultiItemGetRequest(knoVersionIds, supervisionVersionIds));
    const dictionaryValue: IDictionaryValues<ISubjectType> = yield fetchSubjectTypesMultiDictionary(
      knoVersionIds,
      supervisionVersionIds,
    );

    yield put(dictionariesSubjectTypesMultiItemGetSuccess(dictionaryValue, knoVersionIds, supervisionVersionIds));
  }
  function* funcCatch() {
    yield put(dictionariesSubjectTypesMultiItemGetFailure(knoVersionIds, supervisionVersionIds));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectKindsMultiDictionarySaga(knoVersionIds: string[], supervisionVersionIds: string[]) {
  function* funcTry() {
    yield put(dictionariesSubjectKindsMultiItemGetRequest(knoVersionIds, supervisionVersionIds));
    const dictionaryValue: IDictionaryValues<ISubjectKind> = yield fetchSubjectKindsMultiDictionary(
      knoVersionIds,
      supervisionVersionIds,
    );

    yield put(dictionariesSubjectKindsMultiItemGetSuccess(dictionaryValue, knoVersionIds, supervisionVersionIds));
  }
  function* funcCatch() {
    yield put(dictionariesSubjectKindsMultiItemGetFailure(knoVersionIds, supervisionVersionIds));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchSubjectSubKindsMultiDictionarySaga(knoVersionIds: string[], supervisionVersionIds: string[]) {
  function* funcTry() {
    yield put(dictionariesSubjectSubKindsMultiItemGetRequest(knoVersionIds, supervisionVersionIds));
    const dictionaryValue: IDictionaryValues<ISubjectKind> = yield fetchSubjectSubKindsMultiDictionary(
      knoVersionIds,
      supervisionVersionIds,
    );

    yield put(dictionariesSubjectSubKindsMultiItemGetSuccess(dictionaryValue, knoVersionIds, supervisionVersionIds));
  }
  function* funcCatch() {
    yield put(dictionariesSubjectSubKindsMultiItemGetFailure(knoVersionIds, supervisionVersionIds));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* dictionariesKnoOrganisationsGetSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const id = getUserInfoOrganisationsParentId(state);
    const searchQuery = getUserInfoOrganisationsSearchQuery(state);
    const knoOrganizationAdminLevelsSelectOptions = getCatalogKnoAdminLevelsSelectOptions(state);
    const adminLevel = getUserInfoOrganisationsAdminLevelCode(state);

    if (!adminLevel && !knoOrganizationAdminLevelsSelectOptions.length) {
      return;
    }
    if (searchQuery) {
      const result: IKnoOrganisationsChildrenResponse = yield fetchKnoErvkOrganizationsSearch({
        query: searchQuery,
        adminLevel: adminLevel || knoOrganizationAdminLevelsSelectOptions[0]?.code,
        searchCriteria: 'ogrn',
        page: '0',
        size: '15',
      });

      yield put(userInfoSetOrganisations(result.list, result.page.toString(), result.pageCount, result.totalCount));
    } else {
      const result: IKnoOrganisationsChildrenResponse = yield fetchKnoErvkOrganisationsChildrenWithAdminLevel({
        knoLevelCode: adminLevel || knoOrganizationAdminLevelsSelectOptions[0]?.code,
        id,
        size: '2000',
      });

      yield put(userInfoSetOrganisations(result.list, result.page.toString(), result.pageCount, result.totalCount));
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* dictionariesKnoOrganisationsGetNextPageSaga() {
  function* funcTry() {
    const state: IRootState = yield select();
    const searchQuery = getUserInfoOrganisationsSearchQuery(state);
    const page = getUserInfoOrganisationsPage(state);
    const currentList = getUserInfoKnoOrganisations(state);
    const nextPage = (+page + 1).toString();
    const adminLevel = getUserInfoOrganisationsAdminLevelCode(state);

    if (!adminLevel) {
      return;
    }
    if (searchQuery) {
      const result: IKnoOrganisationsChildrenResponse = yield fetchDictionaryKnoOrganisationsSearch({
        query: searchQuery,
        adminLevel,
        page: nextPage,
        size: '15',
      });

      yield put(
        userInfoSetOrganisations(
          [...currentList, ...result.list],
          result.page.toString(),
          result.pageCount,
          result.totalCount,
        ),
      );
    }
  }

  yield sagaWrapper({
    funcTry,
  });
}

function* fetchConditionTypesDictionarySaga(uniqueUuid?: string) {
  function* funcTry() {
    yield put(dictionariesConditionTypesItemGetRequest(uniqueUuid));
    const reasonTypes: IKnmReasonType[] = yield fetchConditionTypesDictionary(uniqueUuid);

    yield put(dictionariesConditionTypesItemGetSuccess(reasonTypes, uniqueUuid));
  }
  function* funcCatch() {
    yield put(dictionariesConditionTypesItemGetFailure(uniqueUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* supervisionDictionaryValueGetHandler(action: ActionType<typeof supervisionDictionaryValueGet>) {
  const { knoDictionaryVersionUUID, supervisionDictionaryVersionUUID } = action.payload;
  const status: DictionaryStatusesEnum | undefined = yield select(
    getDictionariesItemValueStatus,
    DictionaryUUIDsEnum.SUPERVISION_TYPE,
    supervisionDictionaryVersionUUID,
  );

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield fetchSupervisionDictionaryValueSaga(knoDictionaryVersionUUID, supervisionDictionaryVersionUUID);
  } else if (status === DictionaryStatusesEnum.SUCCEEDED) {
    yield put(
      dictionariesItemValueGetAlreadyLoad(DictionaryUUIDsEnum.SUPERVISION_TYPE, supervisionDictionaryVersionUUID),
    );
  }
}

function* fetchSupervisionDictionaryValueSaga(
  knoDictionaryVersionUUID: string,
  supervisionDictionaryVersionUUID: string,
) {
  function* funcTry() {
    yield put(dictionariesItemValueGetRequest(DictionaryUUIDsEnum.SUPERVISION_TYPE, supervisionDictionaryVersionUUID));
    const dictionaryVersion: IDictionaryVersion = yield fetchSupervisionDictionaryValue(
      knoDictionaryVersionUUID,
      supervisionDictionaryVersionUUID,
    );
    const dictionaryValue: IDictionaryValue<IDictionaryValueTypeById[typeof DictionaryUUIDsEnum.SUPERVISION_TYPE]> = {
      idValue: dictionaryVersion.id,
      value: parseDictionaryVersionValue<IDictionaryValueTypeById[typeof DictionaryUUIDsEnum.SUPERVISION_TYPE]>(
        dictionaryVersion,
      ),
    };

    yield put(
      dictionariesItemValueGetSuccess(
        DictionaryUUIDsEnum.SUPERVISION_TYPE,
        supervisionDictionaryVersionUUID,
        dictionaryValue,
      ),
    );
  }
  function* funcCatch() {
    yield put(dictionariesItemValueGetFailure(DictionaryUUIDsEnum.SUPERVISION_TYPE, supervisionDictionaryVersionUUID));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchApplicationConditionSubjectsDictionarySaga(conditionUuid?: string, orderVersionUuid?: string) {
  function* funcTry() {
    yield put(dictionariesApplicationConditionSubjectsItemGetRequest(conditionUuid, orderVersionUuid));
    const dictionaryValue: IApplicationConditionSubject[] = yield fetchApplicationConditionSubjects(
      conditionUuid,
      orderVersionUuid,
    );

    yield put(dictionariesApplicationConditionSubjectsItemGetSuccess(dictionaryValue, conditionUuid, orderVersionUuid));
  }
  function* funcCatch() {
    yield put(dictionariesApplicationConditionSubjectsItemGetFailure(conditionUuid, orderVersionUuid));
  }
  yield sagaWrapper({
    funcTry,
    funcCatch,
  });
}

function* fetchFederalLawsSaga() {
  const status: DictionaryStatusesEnum = yield select(getFederalLawsStatus);

  if (!status || status === DictionaryStatusesEnum.IDLE) {
    yield put(dictionariesFederalLawsGetRequest());

    try {
      const rawData: { id: number; value: string }[] = yield fetchDictionaryValues(
        DictionaryUUIDsEnum.FEDERAL_LAWS,
        -1,
      );

      const parsedData = rawData.map(item => ({
        idValue: String(item.id),
        value: JSON.parse(item.value) as IFederalLawErvk,
      }));

      const dictionaryValue: IDictionaryValues<IFederalLawErvk> = {
        idDictionary: DictionaryUUIDsEnum.FEDERAL_LAWS,
        values: parsedData,
      };

      yield put(dictionariesFederalLawsGetSuccess(dictionaryValue));
    } catch (error) {
      console.error('Failed to fetch federal laws:', error);
      yield put(dictionariesFederalLawsGetFailure());
    }
  }
}

function* dictionariesFindSubjectKindSelectOptionsByQuerySaga(
  action: ActionType<typeof dictionariesFindSubjectKindSelectOptionsByQuery>,
) {
  const { query, callback } = action.payload;
  const result: IDictionaryValues<ISubjectKind> = yield fetchSubjectKindsDictionaryByQuery(query);
  const options = result.values.map(item => createDictionarySubjectKindSelectOption(result.idDictionary, item));

  callback(options);
}

function* dictionariesFindSubjectSubKindSelectOptionsByQuerySaga(
  action: ActionType<typeof dictionariesFindSubjectSubKindSelectOptionsByQuery>,
) {
  const { query, callback } = action.payload;
  const result: IDictionaryValues<ISubjectKind> = yield fetchSubjectSubKindsDictionaryByQuery(query);
  const options = result.values.map(item => createDictionarySubjectKindSelectOption(result.idDictionary, item));

  callback(options);
}

function* dictionariesGetDocTargetSelectOptionsSaga(
  action: ActionType<typeof dictionariesGetDocTargetSelectOptionsByQuery>,
) {
  const { query, callback } = action.payload;
  const result: IPermitDocs[] = yield findDocTargetsDictionary(query);
  const options = result.map(item =>
    createDictionaryPermitDocsSelectOption(DictionaryUUIDsEnum.PERMIT_DOCS, {
      idValue: item.targetId,
      value: item,
    }),
  );

  callback(options);
}

function* fetchFilteredFederalLawsSaga(action: ReturnType<typeof dictionariesFilteredFederalLawsGet>) {
  const { knoVersionId, isPm } = action.payload;

  try {
    yield put(dictionariesFilteredFederalLawsGetRequest());
    const fetchFn = isPm ? fetchFederalLawsByKnoDirect : fetchFederalLawsByKno;
    const lawNumbers: string[] = yield fetchFn(knoVersionId);

    const allFederalLaws: IDictionaryValues<IFederalLawErvk> | null = yield select(
      (state: IRootState) => state.dictionaries.federalLaws,
    );

    if (!allFederalLaws || !allFederalLaws.values) {
      yield put(
        dictionariesFilteredFederalLawsGetSuccess({
          idDictionary: DictionaryUUIDsEnum.FEDERAL_LAWS,
          values: [],
        }),
      );

      return;
    }

    const filteredValues = allFederalLaws.values.filter(law => lawNumbers.includes(law.value.number));

    yield put(
      dictionariesFilteredFederalLawsGetSuccess({
        idDictionary: DictionaryUUIDsEnum.FEDERAL_LAWS,
        values: filteredValues,
      }),
    );
  } catch (error) {
    yield put(dictionariesFilteredFederalLawsGetFailure());
  }
}
